import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";
import { Movies } from "./Pages/Movies/Movies";
import { Profile } from "./Pages/Profile/Profile";
import TermsConditions from "./Pages/TermsConditions/TermsConditions";
import Cookies from "./Pages/Cookies/Cookies";
import Privacy from "./Pages/Privacy/Privacy";
import Contact from "./Pages/Contact/Contact";
//must fetch data from API call to pass to children (Movies.js, Profile.js)
//in the meantime, must use starter data. so must import starter data file.
// import { starterData } from "./Data/moviesStarterData"; //collection
// import { titlesStarterData } from "./Data/titlesStarterData"; //array of strings
import "./App.css";

const App = () => {
  const [titles, setTitles] = useState([
    "Free Willy",
    "Frozen",
    "Titanic",
    "Moonlight",
    "Up",
    "Pulp Fiction",
    "The Negotiator",
  ]);
  const [movieData, setMovieData] = useState([]);

  const getMovie = async (title) => {
    //gets environment variable from Netlify
    let apikey = process.env.REACT_APP_API_KEY;
    let i = "tt3896198";
    try {
      let response = await fetch(
        `https://www.omdbapi.com/?i=${i}&apikey=${apikey}&t=${title}`
        // `http://www.omdbapi.com/?apikey=${apikey}&t=${title}`
      );
      let data = await response.json();
      // console.log(data);
      return title.toUpperCase() === data.Title.toUpperCase()
        ? data
        : data.Title === `${title} not found`;
    } catch (e) {
      console.log(e);
    }
  };
  const getMoviesCollection = async (newTitles) => {
    let movieDataArray = await Promise.all(
      newTitles.map((title) => {
        let obj = getMovie(title);
        // console.log(obj);
        return obj;
      })
    );
    setMovieData(movieDataArray);
    // console.log(movieDataArray);
    setTitles(newTitles);
    return movieDataArray;
  };

  const getTitleCards = (titlesArray) => {
    // console.log(titlesArray, " from profile form");
    setTitles(titlesArray);
  };

  useEffect(() => {
    getMoviesCollection(titles);
  }, [titles]);

  // <Router basename=‘/’>
  //           <Route path=‘/enter-pin’
  //             render={(props) =>
  //               <EnterPin {...props} appLanguage={this.state.appLanguage} authenticateUser={this.authenticateUser} />
  //             } />

  //           <Route path=‘/’ exact
  //             render={(props) =>
  //                   <SplashPage {...props} appLanguage={this.state.appLanguage} />
  //             }
  //           />

  //           <Route path=‘/home’
  //             render={(props) =>
  //                   <Home {...props} appLanguage={this.state.appLanguage} />
  //             }
  //           />
  // </Router>

  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route
          path="/"
          // exact
          element={<Movies data={movieData} />}
        />
        <Route
          path="profile"
          element={
            <Profile
              data={movieData}
              handleCallback={(titles) => getTitleCards(titles)}
            />
          }
        />
        <Route path="terms" element={<TermsConditions />} />
        <Route path="cookies" element={<Cookies />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="contact" element={<Contact />} />
      </Routes>
      <Footer />
    </div>
  );
};

export default App;
